export function humanDuration(seconds) {
  let theTime = parseInt(seconds)
  let middle= 0
  let hour= 0
  if (theTime > 60) {
    middle= parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (middle > 60) {
      hour= parseInt(middle / 60)
      middle= parseInt(middle % 60)
    }
  }
  // let result = "" + parseInt(theTime) + "秒"
  let result = ""
  if(middle > 0) {
    result = "" + parseInt(middle) + "分钟" + result
  }
  if(hour> 0) {
    result = "" + parseInt(hour) + "小时" + result
  }
  return result
  // return '1小时整'
}

export function humanDateTime(timestamp) {
  let date = new Date(timestamp * 1000)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = date.getDate() + ' '
  let h = date.getHours() + ':'
  // let m = date.getMinutes()
  let m = (date.getMinutes()<10?'0':'') + date.getMinutes()
  // let s = date.getSeconds()
  // return Y + M + D + h + m + s
  return Y + M + D + h + m
}
